/**
 * @fileoverview A boundary expressing the min and max of the distribution.
 */

import React from 'react'
import colors from '../../colors'

export default function RangeFence({ x: x1, y1, y2, width }) {
  if (x1 == null || y1 == null || y2 == null) {
    return null
  }

  let x2 = x1 + width
  let centerX = x1 + width * 0.5

  return (
    <g stroke={colors.defaultGray} opacity="0.6">
      {/* max */}
      <line x1={x1} x2={x2} y1={y2} y2={y2} />

      {/* meridian */}
      <line x1={centerX} x2={centerX} y1={y1} y2={y2} />

      {/* min */}
      <line x1={x1} x2={x2} y1={y1} y2={y1} />
    </g>
  )
}



// WEBPACK FOOTER //
// /home/runner/work/web-interactive/web-interactive/lib/components/charts/shapes/easing-box/range-fence.js